import React from 'react'
import { ToggleSwitch } from '../ui/ToggleSwitch'

// Shared form primitives for the person event create/edit flows.
// Extracted from CreatePersonEventPage so create (guided + form) and edit stay in sync.

export function Field({
  label, htmlFor, hint, error, required, children,
}: {
  label: string
  htmlFor?: string
  hint?: string
  error?: string
  required?: boolean
  children: React.ReactNode
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={htmlFor} className="text-[13px] font-semibold text-ink-2 flex gap-1">
        {label}
        {required && <span className="text-warn">*</span>}
      </label>
      {hint && <div className="text-[11.5px] text-muted -mt-1">{hint}</div>}
      {children}
      {error && <div className="text-[12px] text-[#A33A2A]">{error}</div>}
    </div>
  )
}

export function SectionCard({ title, children }: { title?: string; children: React.ReactNode }) {
  return (
    <div className="bg-surface border border-line-soft rounded-2xl px-4 sm:px-6 py-[22px]">
      {title && (
        <div className="text-[13px] font-bold text-ink-2 tracking-[0.04em] uppercase mb-[18px]">
          {title}
        </div>
      )}
      {children}
    </div>
  )
}

export function ModuleToggle({
  icon,
  iconBg,
  iconColor,
  label,
  suggested,
  on,
  onToggle,
  children,
}: {
  icon: React.ReactNode
  iconBg?: string
  iconColor?: string
  label: string
  suggested?: boolean
  on: boolean
  onToggle: () => void
  children?: React.ReactNode
}) {
  return (
    <div className="border border-line-soft rounded-xl overflow-hidden bg-surface">
      <div
        className="flex items-center gap-3 px-4 py-3.5 cursor-pointer select-none"
        onClick={onToggle}
      >
        <div
          className="w-[34px] h-[34px] rounded-[10px] flex items-center justify-center shrink-0"
          style={{ background: iconBg ?? 'var(--s2)', color: iconColor ?? 'var(--ink-2)' }}
        >
          {icon}
        </div>
        <span className="text-[14px] font-medium text-ink flex-1">{label}</span>
        {suggested && (
          <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-primary-soft text-primary-deep mr-1">
            Suggested
          </span>
        )}
        <ToggleSwitch checked={on} size="sm" />
      </div>
      {on && children && (
        <div className="border-t border-line-soft px-4 pt-3.5 pb-4">
          {children}
        </div>
      )}
    </div>
  )
}
